import React from 'react';
import './ContentEditRow.css';

const ContentEditRow = (props) => {
    return (
        <div className="cer-row">
            <div className="cer-icon-wrap">
                {props.icon}
            </div>
            <div className="cer-info">
                <p className="cer-title">{props.title}</p>
                <p className="cer-sub">{props.sub}</p>
                <p className="cer-time">{props.time}</p>
            </div>
        </div>
    );
};

export default ContentEditRow;